// export const DOMAIN = "http://localhost:4000"; 
// export const DOMAIN = "https
// ://f.alamonianca1.life"; //4
// export const DOMAIN = "https://api.elephant.bro.zvshsuddhdndnmxmx4.fun"; //3
// export const DOMAIN = "https://nipa.alamonianca1.life"; //2
// export const DOMAIN = "https://api.elephant.zvshsuddhdndnmxmx4.fun"; //1
export const DOMAIN = "https://tapi.alamonianca1.life"; //0- tay

export const DOMAIN_AUTH = `${DOMAIN}/api/auth`;
export const DOMAIN_FB = `${DOMAIN}/api/fb/`;